module.exports = __webpack_public_path__ + "static/media/recursos_humanos.ff2d8478.jpeg";